import useResource from "./useResource";
import useIdentity from "./useIdentity";
import useData from "./useData";

import { LEAD_GEN_REGISTER_URL, PUBLISHER } from "../conf";

const useSendOfferEmail = ({ brandId }) => {
	const {
		scrapedInformation: { first_name = "", shopify_order_id = null } = {},
		brands,
		session_id,
	} = useData() || {};
	const { user: { email = "" } = {} } = useIdentity();

	return useResource(
		{
			url: LEAD_GEN_REGISTER_URL,
			method: "POST",
			data: {
				email,
				first_name: first_name || "",
				last_name: "",
				publisher_id: PUBLISHER,
				brand_id: brandId,
				displayed_brand_ids: Array.isArray(brands)
					? brands.map(({ id }) => id)
					: [],
				session_id,
				shopify_order_id,
			},
		},
		false
	);
};

export default useSendOfferEmail;
